import { create } from "zustand";

type TabStore = {
  tab: "active" | "archive";
  setTab: (arg: "active" | "archive") => void;
};

export const useTabStore = create<TabStore>((set) => ({
  tab: "active",
  setTab: (arg) => set({ tab: arg }),
}));
